export const LoadingConst = 
    {
        colorPrimary: '#182844',
        colorSecondary:'#d7b615'
    }    
